import React from "react";

function Email() {

  const enviarCorreo = () => {

    const fecha = new Date();

    const asunto = "Aviso " + fecha.toLocaleString();

    const correo =
      "mailto:correo1@empresa.com,correo2@empresa.com" +
      "?subject=" + encodeURIComponent(asunto) +
      "&body=" + encodeURIComponent(
        "Correo generado automáticamente."
      );

    window.location.href = correo;
  };


  return (
    <div>
      <button onClick={enviarCorreo}>
        Enviar correo
      </button>
    </div>
  );
}

export default Email;